var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-edit',_vm._g(_vm._b({attrs:{"title":"Slack","toptitle":"Benachrichtigungen anpassen","name":"settings-workspace-slack-notification-edit","width":400}},'base-edit',_vm.$attrs,false),_vm.$listeners),[_c('settings-workspace-slack-notification-form',{attrs:{"workspace":_vm.workspace,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }